import { APP_PERMISSIONS } from '@exam-management/permissions';
import {
  QBankStructureCVModalAction,
  useQBankStructureCVModal,
} from '@exam-management/qbank-structure-cv';
import { AddRoundedIcon, Button, Flex, Text } from '@shared/components';
import { WithPermission } from '@shared/permissions';

export function QBankStructureSettingHeader() {
  const { setAction } = useQBankStructureCVModal();

  const onClick = () => {
    setAction(QBankStructureCVModalAction.ADD_MEMBER_TO_QBANK_STRUCTURE);
  };

  return (
    <Flex
      sx={(theme) => ({
        justifyContent: 'space-between',
        p: theme.spacing(4, 6),
      })}
    >
      <Text variant='h3'>Access and Visibility</Text>
      <WithPermission requiredPermission={APP_PERMISSIONS.QBANK.SETTING.UPDATE}>
        <Button onClick={onClick} startIcon={<AddRoundedIcon />}>
          Add Member
        </Button>
      </WithPermission>
    </Flex>
  );
}
